import { useState } from "react";
import ProjectDetail from "./ProjectDetail";
import HeadingWithNubbon from "../components/HeadingWithNubbon";
import ProjectList from "../components/ProjectList";
import { useProjects } from "../features/projects/useProjects";
import Spinner from "../components/Spinner";

function Projects() {
    const [activeProject, setActiveProject] = useState(null);
    const { isLoading, projects, error } = useProjects();

    if (isLoading) return <Spinner />;
    if (error) return <p>Projecten konden niet worden geladen.</p>;

    return (
        <section
            className="projects main-section"
            id="projects"
        >
            <HeadingWithNubbon text={"Projecten"} />
            {!activeProject && (
                <ProjectList
                    setActiveProject={setActiveProject}
                    projects={projects}
                />
            )}
            {activeProject && (
                <ProjectDetail
                    project={projects.find(
                        (project) => project.title === activeProject,
                    )}
                    setActiveProject={setActiveProject}
                />
            )}
        </section>
    );
}
export default Projects;
